import { render, staticRenderFns } from "./AppointmentSummary.vue?vue&type=template&id=84cbdf5c&scoped=true&"
import script from "./AppointmentSummary.vue?vue&type=script&lang=js&"
export * from "./AppointmentSummary.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentSummary.vue?vue&type=style&index=0&id=84cbdf5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cbdf5c",
  null
  
)

export default component.exports